<div class="principal">
	<img src="../../assets/images/welcome-parameters.svg" alt="search" />
	<h2>Links</h2>
	<p>Aún no haz ingresado los parámetros de búsqueda</p>
</div>
